<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <el-row>
        <el-form class="searchForm" ref="form" :model="form" label-width="90px" style="margin-top: 20px">
          <el-col :md="12" :lg="8" :xl="6">
            <el-form-item label="申请时间">
              <el-date-picker style="width: 100%" type="daterange" :default-time="['00:00:00', '23:59:59']" start-placeholder="开始日期" end-placeholder="结束日期" v-model="form.timeRange" format="yyyy年MM月dd日" value-format="yyyy-MM-dd H:m:s"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="8" :xl="6">
            <el-form-item label="文章标题">
              <el-input placeholder="模糊检索" v-model="form.title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="loadData">搜索</el-button>
          </el-col>
        </el-form>
      </el-row>

      <div style="padding: 20px 0">
        <el-button type="warning" :disabled="!flag" @click="auditAll">批量同意退款</el-button>
        <el-button type="danger" :disabled="!flag" @click="rejectAll">批量拒绝退款</el-button>
        <el-button type="primary" :disabled="!flag" @click="exportXLS">导出记录</el-button>
      </div>

      <el-row>
        <el-col :span="24">
          <el-table ref="tableData" :data="tableData" @select-all="selAll" @selection-change="selChange" stripe style="width: 100%">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column type="index" width="50"> </el-table-column>

            <el-table-column prop="createTime" align="center" label="申请时间" width="120">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>

            <el-table-column prop="title" label="稿件标题" min-width="200">
              <template slot-scope="scope">
                <h3>{{ scope.row.title }}</h3>
              </template>
            </el-table-column>
            <el-table-column prop="authorName" label="作者"></el-table-column>
            <el-table-column prop="contactTelephone" label="联系电话"></el-table-column>

            <el-table-column prop="orderNo" label="订单编号"></el-table-column>
            <el-table-column prop="irspRef" label="支付流水号"></el-table-column>
            <el-table-column prop="payAmount" label="支付金额"></el-table-column>
            <el-table-column prop="payTime" align="center" label="支付时间" width="120">
              <template slot-scope="scope">
                {{ scope.row.payTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>
            <el-table-column prop="payAmount" label="原支付金额"></el-table-column>
            <el-table-column prop="deductAmount" label="扣款金额（查重检测费）"></el-table-column>
            <el-table-column prop="refundAmount" label="申请退款金额"></el-table-column>

            <el-table-column prop="title" label="状态">
              <template slot-scope="scope">
                <el-tag type="primary" v-if="scope.row.status == 1">待退款</el-tag>
                <el-tag type="success" v-else-if="scope.row.status == 2">已退款</el-tag>
                <el-tag type="danger" v-else-if="scope.row.status == 3">已拒绝退款</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <div style="margin: 20px 0 0 -5px">
        <el-pagination background layout="total,sizes,prev, pager, next,jumper" :total="total" :page-sizes="[20, 30, 50, 100]" :page-size="pageSize" :current-page="curPage" @size-change="pageSizeChange" @current-change="pageChange"> </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import financeApi from "@/api/finance"
import attachUtil from "@/utils/attachUtil"
export default {
  components: { PageHeader },
  data() {
    return {
      f_type: "1",
      headLinks: [{ path: "", title: "待退款记录" }],
      form: {
        timeRange: "",
        author: "",
        title: "",
        status: 1,
        statusResult: "0,2",
      },
      flag: false,

      curPage: 1,
      pageSize: 20,
      tableData: [],
      total: 0,
    }
  },
  mounted() {
    this.loadData()
  },

  methods: {
    loadData() {
      this.tableData = []
      financeApi.getList(this.curPage, this.pageSize, this.form.timeRange, this.form.author, this.form.title, this.form.status, this.form.statusResult).then((res) => {
        this.tableData = res.rows
      })
    },

    selAll() {
      this.flag = this.$refs.tableData.selection.length > 0
    },
    selChange() {
      this.flag = this.$refs.tableData.selection.length > 0
    },

    auditAll() {
      let selRows = this.$refs.tableData.selection
      let ids = []
      let totalMoney = 0
      selRows.forEach((element) => {
        ids.push(element.refundId)
        totalMoney += element.refundAmount
      })
      this.$confirm("退款总" + selRows.length + "条记录，总金额<span class='money'>" + totalMoney + "</span>元，退款将从原路返回, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        dangerouslyUseHTMLString: true,
      }).then(() => {
        financeApi.audit(2, ids).then((res) => {
          if (res.code == 0) {
            this.$notify.success({
              title: "成功",
              message: res.msg,
            })
            this.loadData()
            this.getStat()
          } else {
            this.$notify.error({
              title: "错误",
              message: res.msg,
            })
          }
        })
      })
    },

    rejectAll() {
      let selRows = this.$refs.tableData.selection
      let ids = []
      selRows.forEach((element) => {
        ids.push(element.refundId)
      })
      this.$confirm("拒绝总" + selRows.length + "条记录的退款申请（可在“已处理退款记录”恢复）, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        dangerouslyUseHTMLString: true,
      }).then(() => {
        financeApi.audit(3, ids).then((res) => {
          if (res.code == 0) {
            this.$notify.success({
              title: "成功",
              message: res.msg,
            })
            this.loadData()
            this.getStat()
          } else {
            this.$notify.error({
              title: "错误",
              message: res.msg,
            })
          }
        })
      })
    },

    exportXLS() {
      let selRows = this.$refs.tableData.selection
      let ids = []
      selRows.forEach((element) => {
        ids.push(element.refundId)
      })

      financeApi.exportXLS(ids).then((res) => {
        if (res.type != "application/octet-stream") {
          this.$alert("下载失败", "错误", {
            confirmButtonText: "确定",
          })
        } else {
          attachUtil.download(res, "待退款记录表.xls")
        }
      })
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.pageChange(1)
    },

    pageChange(curPage) {
      this.curPage = curPage
      this.loadData()
    },
  },
}
</script>
